import React, {Component} from 'react';
import {AgencyHeader} from "../agency/AgencyHeader"
import {UserInfo} from "./UserInfo";
import {UserEmailAlerts} from "./UserEmailAlerts";

export class UserSettings extends Component {
    render() {
        return (
            <section className="section-content">
                <AgencyHeader/>
                <div className="section-body h-items">
                    <UserInfo/>
                    <UserEmailAlerts/>
                </div>

            </section>
        )
    }
}
